import React, { useEffect } from 'react'
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import './my-quests-list.styles.scss';
import PlayerRecordsList from '@/components/SHARED/player-records-list/player-records-list.component';

const MyQuestsList = ({
  gameData,
  playerData,
  gameElements
}) => {

  useEffect(() => {
    if (!gameData?.gameName) return;
    const pageTitleEl = document.getElementById('page-title');
    if (pageTitleEl) {
      pageTitleEl.innerText = 'Completed Quests';
    }
    changeDocumentTitle(`Completed Quests | ${gameData?.gameName}`);
  }, [gameData?.gameName])

  return (
    <div className='completed-quests-list'>
      <PlayerRecordsList
        gameData={gameData}
        playerData={playerData}
        gameElements={gameElements}
        activityType='questCompleted'
        title='Completed Quests'
        summaryLabel='Completed Quests'
        summaryIcon='/images/icons/sidequest.png'
        summaryCount={
          playerData?.quests
            ? Object.values(playerData.quests).filter(q => q.complete).length
            : 0
        }
        emptyText='No completed quests yet...' />
    </div>
  )
}

export default MyQuestsList
